/** Recorded JSON values, including scalar and absent historical payloads. */
export type JsonValue =
  | null
  | boolean
  | number
  | string
  | JsonValue[]
  | { [key: string]: JsonValue }

export function isJsonObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value)
}

/** Select known form fields without rewriting the original stored JSON. */
export function jsonObject(value: unknown): Record<string, unknown> {
  return isJsonObject(value) ? value : {}
}

export function recordedString(value: unknown): string {
  return typeof value === 'string' ? value : ''
}
